import { ChargebacksQueueFields } from "globalConstants";
import {
	commaAndFloat2Normalizer,
	floatWithComma2Normalizer,
} from "validators";

const { SalesMonthlyVolume, MonthlyVolumesNumberFrom, MonthlyVolumesNumberTo } =
	ChargebacksQueueFields;

const salesMonthlyVolumes = ({ formName = "" }) => ({
	name: SalesMonthlyVolume.name,
	type: "numeric-range" as const,
	placeholder: "Sales Monthly Volumes, $",
	normalize: commaAndFloat2Normalizer,
	normalizeOnBlur: floatWithComma2Normalizer,
	nameInputFrom: MonthlyVolumesNumberFrom.name,
	nameInputTo: MonthlyVolumesNumberTo.name,
	title: "Please Select the Amount Range",
	addon: "$" as const,
	formName,
	groupColumns: [
		{
			name: MonthlyVolumesNumberFrom.name,
			formatLabel: value =>
				`${
					MonthlyVolumesNumberFrom.displayName
				}: ${floatWithComma2Normalizer(value)}`,
		},
		{
			name: MonthlyVolumesNumberTo.name,
			formatLabel: value =>
				`${
					MonthlyVolumesNumberTo.displayName
				}: ${floatWithComma2Normalizer(value)}`,
		},
	],
});

export default salesMonthlyVolumes;
